import React, { useState } from 'react';
import './PasswordInput.css';

// A password <input> with a built-in Show/Hide eye toggle. Drop-in replacement for a
// plain password input: pass the same value/onChange/className/placeholder/etc. and it
// keeps the field's existing styling (the class you pass), adding the eye on the right.
function PasswordInput({ className = '', wrapClassName = '', style, ...rest }) {
  const [show, setShow] = useState(false);
  return (
    <span className={`pw-field ${wrapClassName}`}>
      <input
        {...rest}
        type={show ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: 38, ...(style || {}) }}
      />
      <button
        type="button"
        className="pw-eye"
        tabIndex={-1}
        aria-label={show ? 'Hide password' : 'Show password'}
        title={show ? 'Hide password' : 'Show password'}
        onClick={() => setShow(s => !s)}
      >
        {show ? (
          /* eye-off */
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        ) : (
          /* eye */
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </span>
  );
}

export default PasswordInput;
